import { createAction, props } from '@ngrx/store';

import { Bookmark } from '../models/bookmark';
import { AddBookmarkResponse } from '../models/add-bookmark-response';
import { AppError } from '../errors/app-error';
import { DeleteBookmarkResponse } from '../models/delete-bookmark-response';
import { EnglishProblem, HistoryProblem, NationalLanguageProblem, ScienceProblem } from '../models/problem';
import { SearchBookmarkCondition } from '../models/search-bookmark-condition';
import { SearchBookmarkCountResponse } from '../models/search-bookmark-count-response';

// findBookmarks ------------------------------------------------------------
export const findBookmark = createAction('[Bookmark] Find Bookmark', props<{ userId: string }>());
export const findBookmarkSuccess = createAction('[Bookmark] Find Bookmark Success', props<{ bookmark: Bookmark }>());
export const findBookmarkFailure = createAction('[Bookmark] Find Bookmark Failure');
export const initializeFindBookmarkState = createAction('[Bookmark] Initialize Find Bookmark State');

// addBookmarks ------------------------------------------------------------
export const addBookmark = createAction('[Bookmark] Add Bookmark', props<{ userId: string; subjectId: string; problemId: string }>());
export const addBookmarkSuccess = createAction('[Bookmark] Add Bookmark Success', props<{ response: AddBookmarkResponse }>());
export const addBookmarkFailure = createAction('[Bookmark] Add Bookmark Failure', props<{ error: AppError }>());
export const initializeAddBookmarkState = createAction('[Bookmark] Initialize Add Bookmark State');

// deleteBookmarks ------------------------------------------------------------
export const deleteBookmark = createAction('[Bookmark] Delete Bookmark', props<{ userId: string; subjectId: string; problemId: string }>());
export const deleteBookmarkSuccess = createAction('[Bookmark] Delete Bookmark Success', props<{ response: DeleteBookmarkResponse }>());
export const deleteBookmarkFailure = createAction('[Bookmark] Delete Bookmark Failure', props<{ error: AppError }>());
export const initializeDeleteBookmarkState = createAction('[Bookmark] Initialize Delete Bookmark State');

// findBookmarkCount ------------------------------------------------------------
export const findBookmarkCount = createAction('[Bookmark] Search Bookmark Count', props<{ userId: string; subjectId: string }>());
export const findBookmarkCountSuccess = createAction(
  '[Bookmark] Search Bookmark Count Success',
  props<{ response: SearchBookmarkCountResponse }>()
);
export const findBookmarkCountFailure = createAction('[Bookmark] Search Bookmark Count Failure');
export const initializeFindBookmarkCountState = createAction('[Bookmark] Initialize Search Bookmark Count State');

// findBookmarkProblems
export const findBookmarkProblems = createAction('[Bookmark] Find Bookmark Problems', props<{ condition: SearchBookmarkCondition }>());
export const findBookmarkProblemsSuccess = createAction(
  '[Bookmark] Find Bookmark Problems Success',
  props<{ subjectId: string; problems: EnglishProblem[] | ScienceProblem[] | NationalLanguageProblem[] | HistoryProblem[] }>()
);
export const findBookmarkProblemsFailure = createAction('[Bookmark] Find Bookmark Problems Failure');
export const initializeFindBookmarkProblemsState = createAction('[Bookmark] Initialize Find Bookmark Problems State');

// findBookmarkProblemIds
export const findBookmarkProblemIds = createAction('[Bookmark] Find Bookmark Problem Ids', props<{ condition: SearchBookmarkCondition }>());
export const findBookmarkProblemIdsSuccess = createAction(
  '[Bookmark] Find Bookmark Problem Ids Success',
  props<{ bookmarkProblemIds: string[] }>()
);
export const findBookmarkProblemIdsFailure = createAction('[Bookmark] Find Bookmark Problem Ids Failure');
export const initializeFindBookmarkProblemIdsState = createAction('[Bookmark] Initialize Find Bookmark Problem Ids State');
